import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerBreadcrumbs = () => {
  const handleClickBreadcrumb = event => {
    if (
      containsValidTargetClass(
        ["ter-sub-nav__breadcrumbs__link"],
        event?.target?.classList
      )
    ) {
      const linkText = event?.target?.innerText
      window.dataLayer.push({
        event: "breadcrumb_click",
        breadcrumb_label: linkText,
        breadcrumb_action: "expand",
      })
    }
  }

  const handleClickSibling = event => {
    if (
      containsValidTargetClass(
        ["ter-sub-nav__siblings__link"],
        event?.target?.classList
      )
    ) {
      const linkText = event?.target?.innerText
      window.dataLayer.push({
        event: "breadcrumb_click",
        breadcrumb_label: linkText,
        breadcrumb_action: "sibling",
      })
    }
  }

  const handleClickBreadcrumbDropdown = event => {
    if (
      containsValidTargetClass(
        ["ter-sub-nav__breadcrumbs-collapse__link"],
        event?.target?.classList
      )
    ) {
      const linkText = event?.target?.innerText
      window.dataLayer.push({
        event: "breadcrumb_click",
        breadcrumb_label: linkText,
        breadcrumb_action: "collapse",
      })
    }
  }
  // add handler if relevant listener elem exists
  let queryBreadcrumb,
    querySiblings,
    queryCollapse = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    queryBreadcrumb =
      document?.querySelectorAll(".ter-sub-nav__breadcrumbs__link").length > 0
    querySiblings =
      document?.querySelectorAll(".ter-sub-nav__siblings__link").length > 0
    queryCollapse =
      document?.querySelectorAll(".ter-sub-nav__breadcrumbs-collapse__link")
        .length > 0
  }
  useClickListener(handleClickBreadcrumb, queryBreadcrumb)
  useClickListener(handleClickSibling, querySiblings)
  useClickListener(handleClickBreadcrumbDropdown, queryCollapse)
}

export default DatalayerBreadcrumbs
